import { useEffect } from 'react';

export default function TwitterEmbed({ updateOn }: any) {
  useEffect(() => {
    try {
      const script = document.createElement('script');
      script.src = 'https://platform.twitter.com/widgets.js';
      document.getElementsByTagName('body')[0].appendChild(script);
    } catch {
      /*swallow exception*/
    }
  }, [updateOn]);

  return null;
}
